const doc = [({"da":({"js":({"admin":({"contacts":({"show":({"person":({"user_teams":({"this_contact_doesnt_have_a_user":"Denne kontakt har ikke en bruger."})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;